import { EChartsGeoJSON } from '@lib.core/entities/echarts/echarts-geojson';

export class EChartsGeoJSONDTO {
  [key: string]: any;

  static toEChartsGeoJSON(echartsGeoJSONDTO: EChartsGeoJSONDTO): EChartsGeoJSON {
    return echartsGeoJSONDTO as EChartsGeoJSON;
  }
}